import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ProspectFormService } from "../prospect-form/prospect-form.service";
import { PoModule, PoNotificationService } from "@po-ui/ng-components";
import { FormsModule } from "@angular/forms";

@Component({
  selector: "app-prospect-form",
  templateUrl: "./prospect-form.component.html",
  styleUrls: ["./prospect-form.component.css"],
  standalone: false,
})
export class ProspectFormComponent implements OnInit {
  id: number;
  nome: String;
  nomeFantasia: String;
  tipo: String;
  cgc: String;
  ie: String;
  email: String;
  telefone: String;
  endereco: String;
  numero: String;
  bairro: String;
  cidade: String;
  uf: String;
  ibge: String;
  cep: String;
  prospect: Array<any> = new Array();
  documentLabel: String;
  mask: String;
  minLength: number;
  nameLabel: String;
  temIE = true;

  constructor(
    private router: Router,
    private prospectFormService: ProspectFormService,
    private poNotification: PoNotificationService
  ) {}

  ngOnInit() {
    this.changeType("J");
  }

  retornaEndereco() {
    this.prospectFormService.getEndereco(this.cep).subscribe((response) => {
      this.endereco = response.endereco;
      this.bairro = response.bairro;
      this.cidade = response.cidade;
      (this.uf = response.uf), (this.ibge = response.ibge);
    });
  }

  cancel() {
    this.router.navigate(["/prospect-list"]);
  }

  save() {
    this.prospect.pop();
    this.prospect.push({
      tiporeq: "G",
      nome: this.nome,
      nomeFantasia: this.nomeFantasia,
      tipo: this.tipo,
      cgc: this.cgc,
      inscr: this.ie,
      email: this.email,
      telefone: this.telefone,
      endereco: this.endereco + "," + this.numero,
      bairro: this.bairro,
      municipio: this.cidade,
      uf: this.uf,
      codmun: this.ibge,
      cep: this.cep,
      status: "Pré-Cadastro",
    });
    //console.log(this.prospect[0]);

    this.prospectFormService
      .SalvarCadastro(this.prospect[0])
      .subscribe((response) => {
        this.poNotification.setDefaultDuration(2500);
        this.poNotification.success("Gravado com sucesso!");
        this.router.navigate(["/prospect-list"]);
      });
  }

  changeType(documentType) {
    if (documentType === "F") {
      this.documentLabel = "CPF";
      this.mask = "999.999.999-99";
      this.minLength = 14;
      this.nameLabel = "Nome";
      this.temIE = true;
    } else {
      this.temIE = false;
      this.documentLabel = "CNPJ";
      this.mask = "99.999.999/9999-99";
      this.minLength = 18;
      this.nameLabel = "Razão Social";
    }
  }


}
